import {Component} from 'preact'
import {connect} from 'preact-redux'
import style from './style.scss'

class Button extends Component {
    constructor(props) {
        super(props);
        this.mouseEnter = this.mouseEnter.bind(this);
        this.mouseLeave = this.mouseLeave.bind(this);

        this.state = {
            hover: false
        }
    }

    mouseEnter() {
        this.setState({hover: true})
    }

    mouseLeave() {
        this.setState({hover: false})
    }

    getContainerStyle() {
        const {bgColor, textColor} = this.props
        return {
            backgroundColor: bgColor || '#4dc5e2',
            color: textColor || 'white'
        }
    }

    _renderImage() {
        const {imgCmp} = this.props
        if (imgCmp) {
            return (
                <div className={style.Image}> {imgCmp} </div>
            )
        }
        return null;
    }

    render() {
        const {text, onClick} = this.props
        const containerStyle = this.getContainerStyle()
        return (
            <div className={style.ButtonContainer}
                style={containerStyle}
                onMouseEnter={this.mouseEnter}
                onMouseLeave={this.mouseLeave}
                onClick={onClick}>
                <div className={style.Text}>
                    {text}
                </div>
                {this._renderImage()}
            </div>
        )
    }
 }

export default Button;



// WEBPACK FOOTER //
// ./components/Buttons/Button/index.js